<template>
  <div id="app" :class="{admin : $router.currentRoute.meta.header=='admin'}">
      <transition name="fade">
        <loader-page v-show="loadpage"></loader-page>
      </transition>
      <header-admin :pages="pages" v-if="$router.currentRoute.meta.header=='admin'"></header-admin>
      <app-header :pages="pages" v-if="$router.currentRoute.meta.header=='default'"></app-header>
      <div class="content">
          <router-view/>
      </div>      
      <app-footer v-if="$router.currentRoute.meta.header=='default'"></app-footer>
  </div>
</template>
<script>
import Authentication from "@/components/pages/Authentication";
import Header from '@/components/components/Header'
import Footer from '@/components/components/Footer'
import HeaderAdmin from '@/components/components/HeaderAdmin'
import LoaderPage from '@/components/components/LoaderPage'
  export default {
    data() {
    return {
      loadpage:true,
      pages:[]
    };
  },
    name: 'app',
    components:{
        'app-header': Header,
        'header-admin': HeaderAdmin,
        'app-footer':Footer,
        'loader-page':LoaderPage
    },
    created() {
        this.getPages() 
    window.addEventListener("load",() => {
        if(this.$cookie.get('load')){
            this.loadpage = false
        }else{
            setInterval(() => {
                this.loadpage = false
            }, 3100);
            this.$cookie.set('load', 'load', 1);
        }
    }          
    )
    
  },
  methods: {    
    async getPages() {       
      let { data } = await Authentication.sendRequestNotAuth(
        this,
        "/api/v1/pages",
        "post",
      );
      if (data) {
        this.pages = data;
      }
    },  
  },
  }
</script>
<style lang="scss">
@import "@/assets/styles";
body{
    font-family: Times, "Times New Roman", serif;
    min-height: 100vh;
    background-color: #ccc;
    position: relative;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}

</style>